import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	giftCardsAndProductDetails: null,
};

const giftcards = createSlice({
	name: 'giftcards',
	initialState: initialState,
	reducers: {
		handleGiftCardsAndProductDetails: (state, action) => {
			return {
				...state,
				giftCardsAndProductDetails: action.payload,
			};
		},
	},
});

export const { handleGiftCardsAndProductDetails } = giftcards.actions;
export default giftcards;
